import { Environment } from 'src/app/models/environment.model';

// This file is auto-generated by scripts/sync-env.cjs.
// Loaded from: .env, process.env
export const environment: Environment = {
  name: "jowa",
  brandName: "Jowa",
  appTitle: "Jowa App",
  adminTitle: "Jowa Admin",
  production: false,
  api: {
    url: "https://api.jowaapp.com",
  },
  google: {
    apiKey: "AIzaSyA7zDn8uNDtuLml11f-r37xDqII9bAC_ec",
  },
};
